// @flow
import React from 'react';
import IconBase from 'react-icon-base';

const EditorLeftPaneIcon = (props: any) => {
  return (
    <IconBase viewBox="0 0 64 64" {...props}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="BothPanesIcon" fill="#FFFFFF">
          <g id="Panes" transform="translate(6.000000, 12.000000)">
            <rect id="Rectangle" x="32" y="0" width="20" height="40" rx="2" />
            <rect id="Rectangle" x="0" y="0" width="20" height="40" rx="2" />
          </g>
        </g>
      </g>
    </IconBase>
  );
};

export default EditorLeftPaneIcon;



// WEBPACK FOOTER //
// ./src/components/common/Icons/EditorIcon/EditorBothPanesIcon.js